import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { decrease, increase } from "../redux/cart/actions";

const Cart = ({ id }) => {
    const { products, carts } = useSelector((state) => state);
    const dispatch = useDispatch();

    const { productName } = products?.find((product) => product.id === id);
    const { quantity } = carts?.find((cart) => cart.id === id);

    const increaseHandler = (id) => {
        dispatch(increase({ id }));
    };

    const decreaseHandler = (id) => {
        dispatch(decrease({ id }));
    };

    return (
        <div className="flex justify-between border-b-2 mb-2">
            <div className="text-lg py-2">
                <p>{productName}</p>
            </div>
            <div className="text-lg py-2">
                <div className="flex flex-row space-x-2 w-full items-center rounded-lg">
                    <button
                        onClick={() => decreaseHandler(id)}
                        className="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M18 12H6"
                            />
                        </svg>
                    </button>
                    <p>{quantity}</p>
                    <button
                        onClick={() => increaseHandler(id)}
                        className="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Cart;
